import { Grid } from "@scuf/common";
import TotalizadorAguaMasa from "./components/totalizadorAguaMasa";
import TotalizadorEfluenteTratado from "./components/totalizadorEfluenteTratado";
import "../Tostador/Tostador.css";
import TotalizadorAguaRecupConcentradora from "./components/totalizadorAguaRecupConcentradora";
import PerfilPlantaEfluente from "./components/perfilPlantaEfluente";
import PerfilUsoAgua from "./components/perfilUsoAgua";
import PerfilCorrienteBombasBBA from "./components/perfilCorrienteBombasBBA";
import PerfilClarificador from "./components/perfilClarificador";
import ImpurezasETPTeorico from "./components/impurezasETPTeorico";

export default function PlgEtp() {
  return (
    <>
      <Grid>
        <Grid.Row className="tostador-row">
          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <TotalizadorAguaMasa />
          </Grid.Column>
          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <TotalizadorEfluenteTratado />
          </Grid.Column>

          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <TotalizadorAguaRecupConcentradora />
          </Grid.Column>

          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <PerfilPlantaEfluente />
          </Grid.Column>

          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <PerfilUsoAgua />
          </Grid.Column>

          
          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <PerfilCorrienteBombasBBA />
          </Grid.Column>

          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <PerfilClarificador />
          </Grid.Column>

          <Grid.Column
            className="tostador-column"
            width={6}
            mWidth={12}
            lWidth={12}
            sWidth={12}
          >
            {" "}
            <ImpurezasETPTeorico />
          </Grid.Column>

        </Grid.Row>
      </Grid>
    </>
  );
}
